import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActionListArchivedService } from "./action-list-archived.service";
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-action-list-archived',
  templateUrl: './action-list-archived.component.html',
  styleUrls: ['./action-list-archived.component.scss']
})
export class ActionListArchivedComponent implements OnInit {

  archivedActionList: any = [];
  displayedColumns = ['name', 'star'];
  displayNoRecords: boolean = false;
  bgTextColor = "#000000";

  constructor(
    private _actionListService: ActionListArchivedService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _sharedService: SharedService,
    private _dashboardService: DashboardService
  ) { 
	this._sharedService.searchChange.subscribe(value => {
		this.archivedActionList.filter = value.toLowerCase();
		if (this.archivedActionList.filteredData.length === 0) {
			this.displayNoRecords = true;
		} else {
			this.displayNoRecords = false;
		}
	});
  }

  ngOnInit() {
    this.onInit();
  }

  	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}
	
  	onInit(): void {
		let searchInput = document.getElementById("searchInput");
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
		searchInput["value"] = "";
		this.displayNoRecords = false;
		this.archivedActionList = [];
		this._actionListService.getArchivedActionLists(localStorage.getItem('organization')).subscribe((response) => {
		if (response["success"]) {
			if (response["data"] && response["data"].length > 0) {
			this.archivedActionList = new MatTableDataSource(response["data"]);
			}
		}
		}, (error) => {
			console.log(error);
			this.openSnackBar("Server side error occurred");
		})
  	}

  	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
		  duration: 2000
		});
	}

	restoreArchivedActionList(_id) {
		this._sharedService.confirmationDialog("Are you sure you want to restore the List?", ()=>{
			let requestData = {
				actionTypeId: _id
			};
			this._actionListService.restoreArchivedActionList(requestData).subscribe((response) => {
				if (response["success"]) {
					this._dashboardService.refreshCount([]);
					this.onInit();
					this.openSnackBar(response["message"]);
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

  	deleteActionTypeForms(_id) {
		this._sharedService.confirmationDialog("Are you sure you want to delete the List?", ()=>{
			let requestData = {
				actionTypeId: _id
			};
			this._dashboardService.deleteActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this._dashboardService.refreshCount([]);
					this.onInit();
					this.openSnackBar(response["message"]);
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	onReloadClick(): void {
		this.onInit();
	}
}
